/** @type {import('@vue/compat').ComponentOptions} */
export default {
  methods: {
    login() {
      if (!qktoken) return this.$createModal('login');
    },
    findPaidRule(rights) {
      if (!rights || !rights.length) return null;
      for (let i = 0; i < rights.length; i++) {
        if (rights[i].type === 'money' || rights[i].type === 'credit') {
          return rights[i];
        }
      }
      return null;
    },
    resolvePayCan(can) {
      if (!can.allow) return can;
      if (!qk_global.is_privileged) return can;
      if (can.type !== 'free' && can.type !== 'none') return can;
      const paid = this.findPaidRule(this.data.rights);
      if (!paid) return can;
      return {
        allow: false,
        type: paid.type,
        value: paid.value,
      };
    },
    go() {
      const can = this.resolvePayCan(this.data.current_user.can);
      if (!qktoken && !can.allow && !this.data.current_user.not_login_pay && can.type == 'money') {
        this.login();
      } else if (!can.allow) {
        if (can.type == 'comment') {
          this.$message({ message: '评论并刷新后免费下载！', type: 'warning' });
        } else if (can.type == 'credit' || can.type == 'money') {
          qkpay({
            title: this.data.title,
            order_price: can.value,
            order_type: 'xiazai',
            order_key: this.index,
            post_id: qk_global.post_id,
            type: can.type,
            tag: '资源下载',
          }, can.type);
        } else if (can.type == 'password') {
          this.$createModal('passwordVerify', {
            size: 312,
            loading: false,
            props: {
              data: qk_global.password_verify,
            },
          });
        } else {
          this.$message({ message: '您无权下载，请升级权限！', type: 'warning' });
        }
        return;
      } else {
        window.open(this.data.link);
      }
    },
    payVip() {
      this.$createModal('vip', { size: 720 });
    },
    changeTab(index) {
      if (this.index == index) return;
      this.index = index;
      this.data = this.list[this.index];
      this.$nextTick(() => {
        this.TabscrollTo(this.index);
      });
    },
    TabscrollTo(index) {
      const dom = this.$refs.scrollTab.children[0];

      const clientWidth = this.$refs.scrollTab.clientWidth;
      const offsetLeft = dom.children[index].offsetLeft;
      const offsetWidth = dom.children[index].offsetWidth;

      if (clientWidth > dom.clientWidth) return;

      let left = offsetLeft - clientWidth / 2 + offsetWidth / 2;
      left = left < 0 ? 0 : left;

      left = left + clientWidth >= dom.scrollWidth ? dom.scrollWidth - clientWidth : left;
      this.scroll.scrollTo(-left, 0, 300);
    },
  },
};
